import React, { useCallback, useEffect, useState } from "react";

import "../../../Assets/CSS/bulkorder.css";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import axios from "axios";
import moment from "moment";
import { ClipLoader } from "react-spinners";
import { Box, Modal, IconButton } from "@mui/material";
import { Typography } from "@material-ui/core";
import { useFormik } from "formik";
import Select from "react-select";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

function OMSChildOrderList({ state, searchOrderId, childOrderStatus }) {
  const [omsData, setOmsData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalResults, setTotalResults] = useState(0);
  const [itemPerPage, setItemPerPage] = useState(15);
  const [pageNumberLimit, setPageLimit] = useState(15);
  const [maxPageLimit, setMaxLimit] = useState(5);
  const [minPageLimit, setMinLimit] = useState(0);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [linkId, setLinkId] = useState(null);
  const [parentOrders, setParentOrders] = useState([]);
  const [isLinking, setIsLinking] = useState(false);

  const getOrders = useCallback(async () => {
    let apiPrefix = "/api/oms/orders?";
    const url = `${apiPrefix}page=${currentPage}&limit=${itemPerPage}&order_id=${searchOrderId}&supplier_loading=${
      state.supplier_loading
    }&ayekart_loan_status=${
      state.approval === "Overdue" ? "Approved" : state.approval
    }&buyer_unloading=${state.buyer_unloading}&shipping_status=${
      state.shipping_status
    }&supplier_status=${state.supplier_status}&grn_document_oms=${
      state.grn_document_oms
    }&decending_order=true&is_parent_linked=${childOrderStatus === "Linked"}`;

    try {
      setLoading(true);
      setTotalResults(0);
      setOmsData([]);
      const { data } = await axios.get(url);
      if (data.status) {
        setTotalResults(data?.orders?.count);
        setOmsData(data?.orders?.rows);
      } else {
        setTotalResults(0);
        setOmsData([]);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  }, [page, currentPage, searchOrderId, state, childOrderStatus]);

  async function getParentOrders() {
    try {
      const url = `/api/parents/orders?page=1&limit=10000&status=Approved`;
      const response = await axios({
        method: "GET",
        url: url,
      });
      setParentOrders(
        response?.data?.parent_orders?.rows?.map((u) => ({
          value: Number(u.id),
          label: u.id,
        }))
      );
    } catch {
      // Error loding buyers
      console.log("Error loading buyers");
    }
  }

  useEffect(() => {
    if (linkId) {
      getParentOrders();
    }
  }, [linkId]);

  useEffect(() => {
    let token;
    if (searchOrderId) {
      clearTimeout(token);
      token = setTimeout(() => {
        getOrders();
      }, 1000);
    } else {
      getOrders();
    }
    return () => clearTimeout(token);
  }, [page, currentPage, searchOrderId, state, childOrderStatus]);

  const pages = [];
  const handleClick1 = (event) => {
    setCurrentPage(Number(event.target.id));
    setPage(Number(event.target.id));
  };
  for (let i = 1; i <= Math.ceil(totalResults / itemPerPage); i++) {
    pages.push(i);
  }

  const handlePrevBtn = (e) => {
    if (currentPage === pages[0]) {
      return;
    }
    setPage(currentPage - 1);
    setCurrentPage(currentPage - 1);
    if ((currentPage - 1) % pageNumberLimit === 0) {
      setMaxLimit(maxPageLimit - pageNumberLimit);
      setMinLimit(minPageLimit - pageNumberLimit);
    }
  };
  const handleNextBtn = (e) => {
    if (currentPage === pages.length) {
      return;
    }
    setPage(currentPage + 1);
    setCurrentPage(currentPage + 1);
    if (currentPage + 1 > maxPageLimit) {
      setMaxLimit(maxPageLimit + pageNumberLimit);
      setMinLimit(minPageLimit + pageNumberLimit);
    }
  };
  const renderPageNumbers = pages
    ? pages.map((number, index) => {
        if (number < maxPageLimit + 1 && number > minPageLimit) {
          return (
            <li
              key={index}
              className={
                currentPage === number ? "page-item active" : "page-item"
              }
              style={{ cursor: "pointer" }}
              onClick={(e) => handleClick1(e)}
            >
              <a
                href="#overview-page"
                className="page-link pb-2 ps-3 pt-2 pe-3"
                id={number}
              >
                {number}
              </a>
            </li>
          );
        } else return null;
      })
    : "";

  const formik = useFormik({
    initialValues: {
      parentOrderId: null,
    },
    validate: (values) => {
      const errors = {};
      if (!values.parentOrderId) {
        errors.parentOrderId = "Parent order required.";
      }
      return errors;
    },
    onSubmit: async (values) => {
      try {
        setIsLinking(true);
        const response = await axios.patch("/api/orders/update", {
          order_id: linkId,
          parent_order_id: Number(values.parentOrderId),
        });
        setIsLinking(false);
        if (response.data.status) {
          getOrders();
          handleClose();
          toast.success("Order link to parent order successfully.");
        } else {
          toast.error("Error while setting parent for order.");
        }
      } catch {
        setIsLinking(false);
        toast.error("Error while setting parent for order.");
      }
    },
  });

  const unlinkOrder = async (orderId) => {
    try {
      const response = await axios.patch("/api/orders/update", {
        order_id: orderId,
        parent_order_id: null,
      });
      if (response.data.status) {
        getOrders();
        toast.success("Order unlinked successfully.");
      } else {
        toast.error("Error while unlinking order.");
      }
    } catch {
      toast.error("Error while unlinking order.");
    }
  };

  const handleClose = () => {
    formik.resetForm();
    setLinkId(null);
  };

  return (
    <div className=" ms-0 ps-0 m-2 pt-0">
      <Modal
        open={!!linkId}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box sx={style}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography id="modal-title" variant="h6" component="h2">
              Link Order (ID:{linkId}) To Parent Order
            </Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box noValidate autoComplete="off" sx={{ mt: 2 }}>
            <form onSubmit={formik.handleSubmit}>
              <Select
                placeholder="Select Parent Order"
                options={parentOrders}
                onChange={({ value }) => {
                  formik.setFieldValue("parentOrderId", value);
                }}
                value={parentOrders?.find(
                  (po) => po.id === formik.values.parentOrderId
                )}
              />
              {formik.errors.parentOrderId && formik.touched.parentOrderId ? (
                <div className="text-red-600 text-sm flex justify-start ms-1">
                  {formik.errors.parentOrderId}
                </div>
              ) : null}
              <Box display="flex" justifyContent="flex-end" mt={3}>
                <Button
                  disabled={isLinking}
                  type="submit"
                  variant="contained"
                  color="primary"
                >
                  Link Order
                </Button>
                <Button
                  type="button"
                  variant="outlined"
                  color="secondary"
                  onClick={handleClose}
                  sx={{ ml: 2 }}
                >
                  Cancel
                </Button>
              </Box>
            </form>
          </Box>
        </Box>
      </Modal>
      <div>
        <TableContainer component={Paper} className="overflow-x-scroll">
          <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
            <TableHead className="shadow">
              <TableRow className="p-2 ">
                <TableCell align="center" className="">
                  Ordered Date
                </TableCell>
                <TableCell align="center">Order ID</TableCell>
                <TableCell align="center">Buyer Name</TableCell>
                <TableCell align="center">Supplier Name</TableCell>
                <TableCell align="center">Approval Status</TableCell>
                {childOrderStatus === "Linked" && (
                  <TableCell align="center">Parent Order Id</TableCell>
                )}
                <TableCell align="center">Action</TableCell>
              </TableRow>
            </TableHead>
            {loading ? (
              <>
                <TableCell></TableCell>
                <TableCell></TableCell>
                {childOrderStatus === "Linked" && <TableCell></TableCell>}
                <TableCell>
                  <ClipLoader />
                </TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
              </>
            ) : (
              <TableBody>
                {omsData?.length === 0 ? (
                  <>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    {childOrderStatus === "Linked" && <TableCell></TableCell>}
                    <TableCell align="center">No Data Found</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                  </>
                ) : (
                  omsData?.map((row, index) => (
                    <TableRow
                      key={row.id}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                    >
                      <TableCell align="center" style={{ width: "120px" }}>
                        {row?.ordered_date
                          ? moment(row?.ordered_date).format("DD-MM-YYYY")
                          : "NA"}
                      </TableCell>
                      <TableCell align="center">
                        {row?.only_bnps?.order_id
                          ? row?.only_bnps?.order_id
                          : "NA"}
                      </TableCell>
                      <TableCell align="center">
                        {row?.buyer_shop?.name ? row?.buyer_shop?.name : "NA"}
                      </TableCell>
                      <TableCell align="center">
                        {row?.op_sourcing_details?.[0]?.firm_name
                          ? row?.op_sourcing_details?.[0]?.firm_name
                          : "NA"}
                      </TableCell>
                      <TableCell align="center">
                        {row?.only_bnps?.ayekart_lvl1_status === "Approved" &&
                        row?.only_bnps?.ayekart_lvl2_status === "Approved"
                          ? "Approved"
                          : "Pending"}
                      </TableCell>
                      {childOrderStatus === "Linked" && (
                        <TableCell align="center">
                          {row.parent_order_id}
                        </TableCell>
                      )}
                      <TableCell align="center">
                        <div>
                          <Button
                            variant="outlined"
                            onClick={() => {
                              if (childOrderStatus === "Linked") {
                                if (
                                  window.confirm(
                                    `You really want to unlink order ID: ${row.id}`
                                  )
                                ) {
                                  unlinkOrder(row.id);
                                }
                              } else {
                                setLinkId(row.id);
                              }
                            }}
                          >
                            {childOrderStatus === "Linked" ? "Unlink" : "Link"}
                          </Button>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            )}
          </Table>
          {omsData?.length !== 0 && (
            <div className="row mx-auto mt-3">
              <div className="col-sm-6 pt-2 d-flex justify-content-start">
                Showing {15 * currentPage - (15 - 1)} to{" "}
                {15 * currentPage > totalResults
                  ? totalResults
                  : 15 * currentPage}{" "}
                entries of {totalResults ? totalResults : ""}
              </div>
              <div className="col-sm-6 d-flex justify-content-end">
                <ul className="pagination">
                  <li className="page-item pt-1 pl-2 pr-2 border">
                    <a
                      href="#overview-page"
                      className={currentPage !== pages[0] ? "show" : "hideBtn"}
                      onClick={(e) => handlePrevBtn(e)}
                    >
                      Prev
                    </a>
                  </li>
                  {renderPageNumbers}
                  <li className="page-item pt-1 pl-2 pr-2 border border-left-0">
                    <a
                      href="#overview-page"
                      className={
                        currentPage !== pages.length ? "show" : "hideBtn"
                      }
                      onClick={(e) => handleNextBtn(e)}
                    >
                      Next
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          )}
        </TableContainer>
      </div>
    </div>
  );
}

export default OMSChildOrderList;
